import {
  GET_FOOD_LOG_RANGE,
  GET_FOOD_LOG_RANGE_SUCCESS,
  GET_FOOD_LOG_RANGE_ERROR,
} from './constants';

const initialState = {
  logs: [],
  loading: false,
  err: null,
};

export default function foodLog(state = initialState, action) {
  switch (action.type) {
    case GET_FOOD_LOG_RANGE:
      return { ...state, loading: true, err: null };
    case GET_FOOD_LOG_RANGE_SUCCESS:
      return {
        ...state,
        logs: Array.isArray(action.payload) ? action.payload : [],
        loading: false,
        err: null,
      };
    case GET_FOOD_LOG_RANGE_ERROR:
      return { ...state, loading: false, err: action.err };
    default:
      return state;
  }
}
